module.exports = {
	"_args": [
		[
			"babel-core@https://registry.npmjs.org/babel-core/-/babel-core-6.4.5.tgz",
			"C:\\src\\astexplorer\\node_modules\\babel6"
		]
	],
	"_from": "babel-core@>=6.2.0 <7.0.0",
	"_id": "babel-core@6.4.5",
	"_inCache": true,
	"_location": "/babel6/babel-core",
	"_phantomChildren": {},
	"_requested": {
		"name": "babel-core",
		"raw": "babel-core@https://registry.npmjs.org/babel-core/-/babel-core-6.4.5.tgz",
		"rawSpec": "https://registry.npmjs.org/babel-core/-/babel-core-6.4.5.tgz",
		"scope": null,
		"spec": "https://registry.npmjs.org/babel-core/-/babel-core-6.4.5.tgz",
		"type": "remote"
	},
	"_requiredBy": [
		"/babel6"
	],
	"_resolved": "https://registry.npmjs.org/babel-core/-/babel-core-6.4.5.tgz",
	"_shasum": "5973f9418cd97fde664186f288c16dc4edb65f4f",
	"_shrinkwrap": null,
	"_spec": "babel-core@https://registry.npmjs.org/babel-core/-/babel-core-6.4.5.tgz",
	"_where": "C:\\src\\astexplorer\\node_modules\\babel6",
	"author": {
		"email": "sebmck@gmail.com",
		"name": "Sebastian McKenzie"
	},
	"dependencies": {
		"babel-code-frame": "^6.3.13",
		"babel-generator": "^6.4.5",
		"babel-helpers": "^6.4.5",
		"babel-messages": "^6.3.13",
		"babel-register": "^6.3.13",
		"babel-runtime": "^5.0.0",
		"babel-template": "^6.3.13",
		"babel-traverse": "^6.4.5",
		"babel-types": "^6.4.5",
		"babylon": "^6.4.5",
		"convert-source-map": "^1.1.0",
		"debug": "^2.1.1",
		"json5": "^0.4.0",
		"lodash": "^3.10.0",
		"minimatch": "^2.0.3",
		"path-exists": "^1.0.0",
		"path-is-absolute": "^1.0.0",
		"private": "^0.1.6",
		"shebang-regex": "^1.0.0",
		"slash": "^1.0.0",
		"source-map": "^0.5.0"
	},
	"description": "Babel compiler core.",
	"devDependencies": {
		"babel-helper-fixtures": "^6.3.13",
		"babel-helper-transform-fixture-test-runner": "^6.3.13",
		"babel-polyfill": "^6.3.13"
	},
	"homepage": "https://babeljs.io/",
	"keywords": [
		"6to5",
		"babel",
		"classes",
		"const",
		"es6",
		"harmony",
		"let",
		"modules",
		"transpile",
		"transpiler",
		"var"
	],
	"license": "MIT",
	"name": "babel-core",
	"optionalDependencies": {},
	"readme": "# babel-core\n\n> Babel compiler core.\n\n## Install\n\n```\n$ npm install babel-core\n```\n\n## Usage\n\n```js\nimport babel from 'babel-core';\n\nconst code = `class Example {}`;\nconst result = babel.transform(code, { /* options */ });\n\nresult.code; // Generated code\nresult.map; // Sourcemap\nresult.ast; // AST\n```\n\nFor more in depth documentation see: http://babeljs.io/docs/usage/api/\n",
	"readmeFilename": "README.md",
	"repository": {
		"type": "git",
		"url": "https://github.com/babel/babel/tree/master/packages/babel-core"
	},
	"scripts": {
		"bench": "make bench",
		"test": "make test"
	},
	"version": "6.4.5"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel6/~/babel-core/package.json
 ** module id = ./node_modules/babel6/node_modules/babel-core/package.json
 ** module chunks = 0
 **/